import React from "react";
import { useLocation, useNavigate } from "react-router";
import { useSubjects } from "../../hooks/useSubjects";
import { PREBOOKING_FORM } from "../../routes/routes";

export const PreBookingParameterValidation = (props: any) => {
    const rawSubjects = useSubjects();
    const subjects = new Set(rawSubjects ?? []);
    const navigate = useNavigate();
    const location = useLocation();
    React.useEffect(() => {
        if (rawSubjects === undefined) {
            return;
        }
        const params = new URLSearchParams(location.search);
        const subjectOne = params.get("subjectOne");
        const subjectTwo = params.get("subjectTwo");
        const subjectThree = params.get("subjectThree");
        const subjectFour = params.get("subjectFour");

        // Subject One has to be exist, in addition it has to be in the list of subjects currently shown
        // Subject Two/Three/Four has to be exist, in addition it has to be in the list of subjects currently shown or be an optional unselected value

        if (subjectOne === null || subjectOne === undefined || !subjects.has(subjectOne)) {
            navigate(PREBOOKING_FORM);
        }
        if (
            subjectTwo === null ||
            subjectTwo === undefined ||
            (!subjects.has(subjectTwo) && subjectTwo !== "Select Subject Two (Optional)")
        ) {
            navigate(PREBOOKING_FORM);
        }
        if (
            subjectThree === null ||
            subjectThree === undefined ||
            (!subjects.has(subjectThree) && subjectThree !== "Select Subject Three (Optional)")
        ) {
            navigate(PREBOOKING_FORM);
        }
        if (
            subjectFour === null ||
            subjectFour === undefined ||
            (!subjects.has(subjectFour) && subjectFour !== "Select Subject Four (Optional)")
        ) {
            navigate(PREBOOKING_FORM);
        }
    }, [rawSubjects]);

    return <>{props.children}</>;
};
